export default __webpack_public_path__ + "static/media/lowes.1a78bd97.svg";